import React from "react";
import { Card, Col, Row } from "react-bootstrap";

import { HorizontalDivider } from "../../../common/components/core";
import { useSelector } from "../../../redux/hooks";
import { currentRolesSelector } from "../../../redux/slices/auth/selectors";
import { BesuClaimListItem } from "../../../types/claim";
import { InvoiceSummary } from "../../../types/invoice";
import { BesuProjectState } from "../../../types/project";
import { formatAmount } from "../../../utils/amount";
import { isUserContractor, isNodeDeveloper } from "../../../utils/role";

import ProjectInfo from "./ProjectInfo";
import { Contact } from "../../../types/common";

type ProjectDetailCardProps = {
    project: BesuProjectState;
    invoiceSummary: InvoiceSummary;
    claims?: BesuClaimListItem[];
    currentContact?: Contact;
};

const ProjectDetailCard = ({
    project,
    invoiceSummary,
    claims,
    currentContact,
}: ProjectDetailCardProps): JSX.Element => {
    const currentRoles = useSelector(currentRolesSelector);

    return (
        <Card.Body className="mb-3 border-0 px-0 py-1">
            <Row xs={3}>
                <Col>
                    <p className="mb-2">
                        <span className="h1">
                            {formatAmount(invoiceSummary.totalPendingAmount)}
                        </span>
                        <span className="ms-2 fw-bold">
                            {invoiceSummary.currency}
                        </span>
                    </p>
                    <p>Pending Amount</p>
                </Col>
                <Col xs={4}>
                    <p className="mb-2">
                        <span className="h1">
                            {formatAmount(invoiceSummary.totalPaidAmount)}
                        </span>
                        <span className="ms-2 fw-bold">
                            {invoiceSummary.currency}
                        </span>
                    </p>
                    {isNodeDeveloper() && (
                        <p>Paid Amount</p>
                    )}
                    {isUserContractor(currentRoles) && (
                        <p>Received Amount</p>
                    )}
                </Col>
                {isNodeDeveloper() && (
                    <Col>
                        <p className="mb-2">
                            <span className="h1">
                                {claims ? claims.length : 0}
                            </span>
                        </p>
                        <p>Number of Claims</p>
                    </Col>
                                    )}
            </Row>
            <HorizontalDivider />
            <ProjectInfo
                project={project}
                showClaim
                claims={claims}
                currentContact={currentContact}
            />
            <HorizontalDivider className="mb-0" />
        </Card.Body>
    );
};

export default ProjectDetailCard;
